import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlacesService {

  private urlRegion: string;
  private urlProvince: string;
  private urlCommune: string;
  private urlCommuneByRegion: string;
  constructor(private http: HttpClient) { 
    this.urlRegion = environment.getBackendUrl('places/region');
    this.urlProvince = environment.getBackendUrl('places/province');
    this.urlCommune = environment.getBackendUrl('places/communes');
    this.urlCommuneByRegion = environment.getBackendUrl('places/commune_by_region');
  }

  public getRegions(): Observable<any> {        
    return this.http.get(this.urlRegion);
  }

  public getProvinces(regionID: number): Observable<any> {        
    return this.http.get(`${this.urlProvince}/${regionID}`);
  }

  public getCommunes(provinceID: number): Observable<any> {        
    return this.http.get(`${this.urlCommune}/${provinceID}`);
  }

  // public getCommunesByRegionID(regionID: number){
  //   return this.http.get(`${this.urlCommuneByRegion}/${regionID}`);
  // }

  public getCommunesByRegionID(regionID: number){
    return this.http.get(`${this.urlCommune}/?region_id=${regionID}`);
  }

}
 